module.exports = __webpack_public_path__ + "img/bq.19bce53a.jpg";